module.exports = __webpack_public_path__ + "img/incident_servicios_publicos_selected.709345d6.svg";